import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';

import {
  BadgeComponent,
  HeadingComponent,
  IconColorDirective,
  IconComponent,
  IconName,
  RtTooltip,
} from '@recruitee/user-interface';

export enum CounterTypes {
  CounterWithLabel,
  CounterWithIcon,
  CounterWithBudget,
}

interface CounterOptions {
  iconName?: IconName;
}

export interface Counter {
  value: string | number;
  label: string;
  type: CounterTypes;
  options?: CounterOptions;
  isVisible: boolean;
}

@Component({
  selector: 'rt-offers-footer-counters',
  templateUrl: './offers-footer-counters.component.html',
  styleUrls: ['./offers-footer-counters.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeadingComponent, BadgeComponent, RtTooltip, IconColorDirective, IconComponent],
})
export class OffersFooterCountersComponent {
  @Input() public counters: Counter[];

  public CounterTypes: typeof CounterTypes = CounterTypes;
  public visibleCounters: Counter[];

  public ngOnChanges(changes: SimpleChanges): void {
    if ('counters' in changes) {
      this.visibleCounters = this.counters.filter(counter => counter.isVisible);
    }
  }

  public trackByCounters(_: number, counter: Counter): string {
    return String(counter.label);
  }
}
